import React, { useState } from "react";
import { Link } from "react-router-dom";
import { API } from "../App";
import axios from "axios";
import { toast } from "sonner";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { Shield, Mail, ArrowLeft, Loader2, CheckCircle } from "lucide-react";

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email) {
      toast.error("Veuillez entrer votre email");
      return;
    }

    setLoading(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setSent(true);
      toast.success("Email envoyé !");
    } catch (error) {
      toast.error(error.response?.data?.detail || "Erreur lors de l'envoi");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#FFF5F7] to-[#FFF0F5] flex flex-col items-center justify-center p-4">
      {/* Logo */}
      <div className="flex items-center gap-2 mb-8">
        <div className="w-12 h-12 rounded-full bg-gradient-to-br from-pink-200 to-pink-100 flex items-center justify-center shadow-lg">
          <Shield size={28} className="text-[#FF3366]" fill="#FF3366" />
        </div>
        <span className="text-3xl font-extrabold text-slate-900" style={{ fontFamily: 'Outfit' }}>
          SHARE
        </span>
      </div>

      <Card className="w-full max-w-md shadow-xl border-0" data-testid="forgot-password-card">
        <CardHeader className="text-center pb-2">
          <CardTitle className="text-xl font-bold">
            {sent ? "Email envoyé !" : "Mot de passe oublié"}
          </CardTitle>
        </CardHeader>
        <CardContent className="pt-4">
          {sent ? (
            <div className="text-center space-y-4">
              <div className="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center mx-auto">
                <CheckCircle className="text-green-600" size={32} />
              </div>
              <p className="text-slate-600">
                Si un compte existe avec l'adresse <strong>{email}</strong>, 
                vous recevrez un email avec un lien pour réinitialiser votre mot de passe.
              </p>
              <p className="text-sm text-slate-500">
                Le lien expire dans 1 heure.
              </p>
              <div className="pt-4 space-y-2">
                <Button
                  variant="outline"
                  className="w-full rounded-xl"
                  onClick={() => {
                    setSent(false);
                    setEmail("");
                  }}
                >
                  Renvoyer un email
                </Button>
                <Link to="/auth">
                  <Button className="w-full btn-guardian rounded-xl">
                    <ArrowLeft size={16} className="mr-2" />
                    Retour à la connexion
                  </Button>
                </Link>
              </div>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4">
              <p className="text-slate-600 text-sm text-center mb-4">
                Entrez votre adresse email et nous vous enverrons un lien pour réinitialiser votre mot de passe.
              </p>
              
              <div className="space-y-2">
                <Label htmlFor="email" className="font-bold">Email</Label>
                <div className="relative">
                  <Mail className="absolute left-3 top-1/2 transform -translate-y-1/2 text-slate-400" size={18} />
                  <Input
                    id="email"
                    type="email"
                    placeholder="votre@email.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="pl-10 rounded-xl h-12"
                    data-testid="forgot-email-input"
                    required
                  />
                </div>
              </div>

              <Button 
                type="submit" 
                className="w-full btn-guardian rounded-xl h-12 text-base"
                disabled={loading}
                data-testid="forgot-submit-btn"
              >
                {loading ? (
                  <>
                    <Loader2 className="animate-spin mr-2" size={18} />
                    Envoi en cours...
                  </>
                ) : (
                  "Envoyer le lien"
                )}
              </Button>

              <div className="text-center pt-2">
                <Link 
                  to="/auth" 
                  className="text-[#FF3366] hover:underline text-sm inline-flex items-center"
                >
                  <ArrowLeft size={14} className="mr-1" />
                  Retour à la connexion
                </Link>
              </div>
            </form>
          )}
        </CardContent>
      </Card>

      <p className="mt-6 text-slate-500 text-sm">
        © 2026 RATE⭐SHARE - Le GPS de la Bienveillance
      </p>
    </div>
  );
};

export default ForgotPasswordPage;
